import TermsAndConditions from './TermsAndConditions';
import { connect } from 'shared/node_modules/react-redux';
import { termsAndConditionsRequestData } from 'shared/state/slices/termsAndConditions/termsAndConditions';

const mapStateToProps = state => {
  return {
    termsAndConditions: state.termsAndConditions,
    playerInfo: state.playerInfo,
    token: state.token.token,
    googleAuth: state.availableServices.googleAuth,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    termsAndConditionsRequestData: payload => {
      dispatch(termsAndConditionsRequestData(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TermsAndConditions);

